const prefix = "NOTICE_";

export const EXPORT_FAILED = prefix + "EXPORT_FAILED";
export const EXPORT_STARTED = prefix + "EXPORT_STARTED";
export const EXPORT_SUCCEEDED = prefix + "EXPORT_SUCCEEDED";
export const GET_TIMELINE_FAILED = prefix + "GET_TIMELINE_FAILED";
export const GET_TIMELINE_STARTED = prefix + "GET_TIMELINE_STARTED";
export const GET_TIMELINE_SUCCEEDED = prefix + "GET_TIMELINE_SUCCEEDED";
export const LIST_CLEAR_CRITERIA = prefix + "LIST_CLEAR_CRITERIA";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_CRITERIA = prefix + "LIST_SET_CRITERIA";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_FILTERS = prefix + "LIST_SET_FILTERS";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const LIST_TOGGLE_EXPAND = prefix + "LIST_TOGGLE_EXPAND";
export const PREVIEW_RESEND_FAILED = prefix + "PREVIEW_RESEND_FAILED";
export const PREVIEW_RESEND_STARTED = prefix + "PREVIEW_RESEND_STARTED";
export const PREVIEW_RESEND_SUCCEEDED = prefix + "PREVIEW_RESEND_SUCCEEDED";
export const PREVIEW_SEND_FAILED = prefix + "PREVIEW_SEND_FAILED";
export const PREVIEW_SEND_STARTED = prefix + "PREVIEW_SEND_STARTED";
export const PREVIEW_SEND_SUCCEEDED = prefix + "PREVIEW_SEND_SUCCEEDED";
export const RESEND_FAILED = prefix + "RESEND_FAILED";
export const RESEND_SET_DATA = prefix + "RESEND_SET_DATA";
export const RESEND_STARTED = prefix + "RESEND_STARTED";
export const RESEND_SUCCEEDED = prefix + "RESEND_SUCCEEDED";
export const SEND_FAILED = prefix + "SEND_FAILED";
export const SEND_STARTED = prefix + "SEND_STARTED";
export const SEND_SUCCEEDED = prefix + "SEND_SUCCEEDED";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const STATE_UNLOAD_LISTING = prefix + "STATE_UNLOAD_LISTING";
export const VIEW_CLEAR = prefix + "VIEW_CLEAR";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
